var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionTypeSaImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 108,
    viewBox: "0 0 125 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.4976,
    y: 10.5059,
    width: 83.682,
    height: 30.2031,
    rx: 2.77093,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.2343,
    y: 10.6426,
    width: 83.0086,
    height: 29.5297,
    rx: 2.4342,
    stroke: "black",
    strokeWidth: 0.673465,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.9058,
    y: 16.1602,
    width: 19.1194,
    height: 19.1194,
    rx: 9.5597,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4655 27.2721V25.3042C42.8369 25.3042 43.9491 24.331 43.9491 23.1311C43.9491 21.9313 42.8369 20.958 41.4655 20.958C40.0941 20.958 38.9819 21.9313 38.9819 23.1311V23.4416",
    stroke: "#344054",
    strokeWidth: 1.0102,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4658 28.6582C41.9586 28.6584 42.3584 29.058 42.3584 29.5508C42.3582 30.0435 41.9585 30.4432 41.4658 30.4434C40.973 30.4434 40.5734 30.0436 40.5732 29.5508C40.5732 29.0578 40.9729 28.6582 41.4658 28.6582Z",
    fill: "#344054",
    stroke: "#344054",
    strokeWidth: 0.0776114
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9045,
    y: 16.1602,
    width: 49.8364,
    height: 2.69386,
    rx: 1.34693,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9045,
    y: 16.1602,
    width: 49.8364,
    height: 2.69386,
    rx: 1.34693,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9045,
    y: 16.1602,
    width: 49.8364,
    height: 2.69386,
    rx: 1.34693,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9045,
    y: 16.1602,
    width: 49.8364,
    height: 2.69386,
    rx: 1.34693,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9048,
    y: 22.8945,
    width: 49.8364,
    height: 2.69386,
    rx: 1.34693,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9048,
    y: 22.8945,
    width: 49.8364,
    height: 2.69386,
    rx: 1.34693,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9048,
    y: 22.8945,
    width: 49.8364,
    height: 2.69386,
    rx: 1.34693,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9048,
    y: 22.8945,
    width: 49.8364,
    height: 2.69386,
    rx: 1.34693,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9048,
    y: 29.6289,
    width: 46.4691,
    height: 2.69386,
    rx: 1.34693,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9048,
    y: 29.6289,
    width: 46.4691,
    height: 2.69386,
    rx: 1.34693,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9048,
    y: 29.6289,
    width: 46.4691,
    height: 2.69386,
    rx: 1.34693,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9048,
    y: 29.6289,
    width: 46.4691,
    height: 2.69386,
    rx: 1.34693,
    fill: "#E3DFE9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.7656,
    y: 42.6123,
    width: 83.5096,
    height: 38.3875,
    rx: 2.77093,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.5343,
    y: 42.449,
    width: 82.8361,
    height: 37.714,
    rx: 2.4342,
    stroke: "black",
    strokeWidth: 0.673465,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 49.3467,
    width: 70.7138,
    height: 2.57483,
    rx: 1.28742,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 49.3467,
    width: 70.7138,
    height: 2.57483,
    rx: 1.28742,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 49.3467,
    width: 70.7138,
    height: 2.57483,
    rx: 1.28742,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 49.3467,
    width: 70.7138,
    height: 2.57483,
    rx: 1.28742,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 55.8008,
    width: 70.7138,
    height: 2.57483,
    rx: 1.28742,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 55.8008,
    width: 70.7138,
    height: 2.57483,
    rx: 1.28742,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 55.8008,
    width: 70.7138,
    height: 2.57483,
    rx: 1.28742,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 55.8008,
    width: 70.7138,
    height: 2.57483,
    rx: 1.28742,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 62.2549,
    width: 70.7138,
    height: 2.57483,
    rx: 1.28742,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 62.2549,
    width: 70.7138,
    height: 2.57483,
    rx: 1.28742,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 62.2549,
    width: 70.7138,
    height: 2.57483,
    rx: 1.28742,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 62.2549,
    width: 70.7138,
    height: 2.57483,
    rx: 1.28742,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 68.709,
    width: 30.2031,
    height: 2.77093,
    rx: 1.38546,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 68.709,
    width: 30.2031,
    height: 2.77093,
    rx: 1.38546,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 68.709,
    width: 30.2031,
    height: 2.77093,
    rx: 1.38546,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1738,
    y: 68.709,
    width: 30.2031,
    height: 2.77093,
    rx: 1.38546,
    fill: "#9BBAC1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15039 57.2245L76.5277 17.9375L8.15039 57.2245Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.618 33.4518L115.948 30.3496L110.618 33.4518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6479 87.7614L54.977 84.6592",
    stroke: "#E3DFE9",
    strokeWidth: 16.7314,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.181 76.7882C114.012 76.875 114.617 77.6208 114.53 78.4525C114.443 79.2842 113.698 79.8889 112.866 79.8021C112.034 79.7153 111.429 78.9695 111.516 78.1378C111.603 77.3061 112.349 76.7014 113.181 76.7882Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.778901
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5398 94.2246C32.9075 94.3673 33.902 95.5937 33.7592 96.9614C33.6164 98.329 32.39 99.3235 31.0224 99.1807C29.6547 99.0379 28.6602 97.8115 28.803 96.4439C28.9458 95.0762 30.1722 94.0818 31.5398 94.2246Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6709 6.2187C61.0386 6.36149 62.0331 7.58785 61.8903 8.9555C61.7475 10.3231 60.5211 11.3176 59.1535 11.1748C57.7858 11.032 56.7913 9.80568 56.9341 8.43803C57.0769 7.07038 58.3033 6.0759 59.6709 6.2187Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98567 37.9902C2.61388 37.9902 3.12393 38.5003 3.12393 39.1285C3.12393 39.7567 2.61388 40.2668 1.98567 40.2668C1.35747 40.2668 0.847412 39.7567 0.847412 39.1285C0.847412 38.5003 1.35747 37.9902 1.98567 37.9902Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.536 30.4893C123.164 30.4893 123.674 30.9993 123.674 31.6275C123.674 32.2557 123.164 32.7658 122.536 32.7658C121.908 32.7658 121.397 32.2557 121.397 31.6275C121.397 30.9993 121.908 30.4893 122.536 30.4893Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.379 5.19238L104.679 0.812337",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.912 2.38281L106.292 3.68223",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60156 79.7754L7.7408 75.351",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03247 77.0215L9.45688 78.1607",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.572 99.541L102.463 95.06",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8523 96.8789L104.333 97.77",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeSaImg);
export default __webpack_public_path__ + "static/media/question_type_sa_img.9a48ed0e0016eb5434ab35408de79104.svg";
export { ForwardRef as ReactComponent };